import {useAppBadgeSync} from "@/hooks/useAppBadgeSync";

/**
 * Renders nothing. It exists only so the badge effect runs under the <Authenticated> guard —
 * reading the unread count is an authenticated call — without the app layout having to host a
 * background effect next to its navigator. Same shape as <PushRegistration/>.
 */
export function NotificationBadgeSync() {
    useAppBadgeSync();
    return null;
}
